import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { UAParser } from "ua-parser-js";

const MIN_SUPPORTED_BROWSER_VERSIONS: Record<string, number> = {
  Chrome: 103,
  Chromium: 103,
  Edge: 103,
  Firefox: 102,
  Opera: 89,
  Safari: 15,
  "Samsung Browser": 19,
  "Mobile Safari": 15
};

type BrowserInfo = {
  name: string;
  majorVersion: number;
};

function getBrowserInfo(): BrowserInfo | undefined {
  const browser = UAParser(window.navigator.userAgent).browser;
  const browserName = browser.name;
  const browserMajorVersion = Number(browser.major);

  if (!browserName || Number.isNaN(browserMajorVersion)) {
    return undefined;
  }

  return { name: browserName, majorVersion: browserMajorVersion };
}

function UnsupportedBrowserWarning() {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  useEffect(() => {
    const browserInfo = getBrowserInfo();

    if (!browserInfo) {
      enqueueSnackbar("Your browser could not be identified and may not be fully supported.", {
        variant: "warning",
        persist: true
      });
      return;
    }

    const minimumVersion = MIN_SUPPORTED_BROWSER_VERSIONS[browserInfo.name];

    if (!minimumVersion || browserInfo.majorVersion < minimumVersion) {
      enqueueSnackbar(t("main.unsupportedBrowser"), {
        variant: "warning",
        persist: true
      });
    }
  }, [enqueueSnackbar, t]);

  return null;
}

export default UnsupportedBrowserWarning;
